import { axiosInstance } from './api';

/** «Подключенные функции» registry (BE services/api/features.py). One answer per
 *  function: switched on / has something to show / what it needs first. */
export type FeatureKey = 'speech' | 'checklists' | 'receipts' | 'sales_plan' | 'visits' | 'reviews' | 'wifi' | 'staff_arrival';

export interface FeatureState {
  enabled: boolean;
  has_content: boolean;
  requirement: 'microphone' | 'router' | 'staff_polygon' | null;
  /** Только sales_plan: выводить карточку на дашборд смены (Алексей 27.10 #2962). */
  dashboard?: boolean;
}

export type ZoneFeatures = Partial<Record<FeatureKey, FeatureState>>;

export const getZoneFeatures = (zoneId: string) =>
  axiosInstance.get<ZoneFeatures>(`/core/api/zones/${zoneId}/features/`);

export const setZoneFeature = (zoneId: string, key: FeatureKey, enabled: boolean) =>
  axiosInstance.put<ZoneFeatures>(`/core/api/zones/${zoneId}/features/${key}/`, { enabled });

/** С какого дня у филиала есть данные: по мониторингу зон и по каждой функции
 *  (YYYY-MM-DD или null). Нужно рекомендованному периоду: если данные моложе
 *  него, рекомендуем «Все данные» (Алексей 17.09). */
export type DataSection = FeatureKey | 'monitoring';
export type ZoneFirstData = Partial<Record<DataSection, { first: string | null; last: string | null }>>;

export const zoneFirstDataKey = (zoneId: string | null | undefined) =>
  zoneId ? ['zone-first-data', String(zoneId)] : null;

export const getZoneFirstData = (zoneId: string) =>
  axiosInstance.get<ZoneFirstData>(`/core/api/zones/${zoneId}/first-data/`).then((r) => r.data);
